export function deepClone(data) {
  return JSON.parse(JSON.stringify(data));
}

export function convertArrayToNamedObjectsArray(array) {
  let returnObject = {};
  array.forEach(unit => {
    returnObject[unit.id] = unit;
  });
  return returnObject;
}

export function loadScript(scriptUrl, callback) {
  let scriptAlreadyLoaded = false;
  document.querySelectorAll('script').forEach(function(e) {
    if (e.getAttribute('src') == scriptUrl) {
      scriptAlreadyLoaded = true;
    }
  });
  if (!scriptAlreadyLoaded) {
    let script = document.createElement('script');
    script.setAttribute('src', scriptUrl);
    document.head.appendChild(script);
    script.onload = () => {
      callback();
    };
  } else {
    callback();
  }
}

export function dynamicSort(property, asc = true) {
  var sortOrder = asc ? 1 : -1;
  if (property[0] === '-') {
    sortOrder = asc ? -1 : 1;
    property = property.substr(1);
  }
  return function(a, b) {
    /* next line works with strings and numbers,
     * and you may want to customize it to your needs
     */
    var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
}

export function sortArrayByObjectProperty(array, sortBy) {
  switch (sortBy) {
    case "nameACS":
      return array.sort((a, b) => a.name.localeCompare(b.name) )
    case "nameDESC":
      return array.sort((a, b) => b.name.localeCompare(a.name))
    case "maintanceDate":
      return array.sort((a, b) => {
        if (a.maintenanceDates.length && !b.maintenanceDates.length)
          return -1
        else if (!a.maintenanceDates.length && b.maintenanceDates.length)
          return 1
        else if (a.maintenanceDates.length && b.maintenanceDates.length) 
          return new Date(a.maintenanceDates[0].date).getTime() - new Date(b.maintenanceDates[0].date).getTime()
        return a.name.localeCompare(b.name)

      })
    default:
      return array
  }
}

export function sortArrayByNestedObjectProperty(array, property, asc = true) {
  if (array == null) {
    return array;
  }
  var sortOrder = asc ? 1 : -1;
  property = property.split('.');
  var propertyIndex = property.length - 1;
  var len = property.length;
  return array.sort(function(a, b) {
    var i = 0;
    while (i < len) {
      if (a === null || a === 1) {
        a = 1;
      } else {
        a = a[property[i]];
      }
      if (b === null || b === -1) {
        b = -1;
      } else {
        b = b[property[i]];
      }
      i++;
    }

    if (a === 1) {
      return a;
    } else if (b === -1) {
      return b;
    } else if (a < b) {
      return -1 * sortOrder;
    } else if (a > b) {
      return 1 * sortOrder;
    } else {
      return 0;
    }
  });
}

export function sortWiresByTimeUntillNextService(array) {
  if (array == null) {
    return array;
  }
  let wireToAdd = [];
  let lowestPriorityWires = [];
  array.forEach(unit => {
    if (unit.wire && unit.wire.state === 4) {
      wireToAdd.push(unit);
    }
  });
  let dict = [];
  array.forEach(unit => {
    let wiresNeedGrinding = [];
    if (unit.wire && unit.wire.state === 2) {
      let difference = 0;
      if (unit.wire.kilograms === 0) {
        lowestPriorityWires.push(unit);
      } else {
        let nextService = 0;
        if (unit.wire.recommendation != null) {
          for (let i = 0; i < unit.wire.recommendation.grindings.length; i++) {
            let grindingValue = unit.wire.recommendation.grindings[i];
            if (grindingValue > unit.wire.kilograms) {
              nextService = grindingValue;
              break;
            }
          }
        }
        if (nextService === 0) {
          if (unit.wire.recommendation != null) {
            if (unit.wire.recommendation.replacement == null) {
              difference = 0;
              dict.push({ difference: difference, unit: unit });
            } else {
              difference = unit.wire.recommendation.replacement - unit.wire.kilograms;
              dict.push({ difference: difference, unit: unit });
            }
          } else {
            lowestPriorityWires.unshift(unit);
          }
        } else {
          difference = nextService - unit.wire.kilograms;
          dict.push({ difference: difference, unit: unit });
        }
      }
    }
  });

  if (dict.length > 0) {
    dict.sort(dynamicSort('difference', true));
    dict.forEach(element => {
      wireToAdd.push(element.unit);
    });
  }
  lowestPriorityWires.forEach(unit => {
    wireToAdd.push(unit);
  });

  dict = [];
  lowestPriorityWires = [];
  array.forEach(unit => {
    if (unit.wire && unit.wire.state != 2 && unit.wire.state != 4) {
      let difference = 0;
      let nextService = 0;
      if (unit.wire.recommendation != null) {
        for (let i = 0; i < unit.wire.recommendation.grindings.length; i++) {
          let grindingValue = unit.wire.recommendation.grindings[i];
          if (grindingValue > unit.wire.kilograms) {
            nextService = grindingValue;
            break;
          }
        }
      }
      if (nextService === 0) {
        if (unit.wire.recommendation != null) {
          if (unit.wire.recommendation.replacement == null) {
            dict.push({ difference: difference, unit: unit });
          } else {
            difference = unit.wire.recommendation.replacement - unit.wire.kilograms;
            dict.push({ difference: difference, unit: unit });
          }
        } else {
          lowestPriorityWires.unshift(unit);
        }
      } else {
        difference = nextService - unit.wire.kilograms;
        dict.push({ difference: difference, unit: unit });
      }
    } else if (unit.wire == null) {
      lowestPriorityWires.push(unit);
    }
  });

  if (dict.length > 0) {
    dict.sort(dynamicSort('difference', true));
    dict.forEach(element => {
      wireToAdd.push(element.unit);
    });
  }
  lowestPriorityWires.forEach(unit => {
    wireToAdd.push(unit);
  });

  return wireToAdd;
}

export function dynamicCustomSort(property, asc = true) {
  var sortOrder = asc ? 1 : -1;
  if (property[0] === '-') {
    sortOrder = asc ? -1 : 1;
    property = property.substr(1);
  }
  return function(a, b) {
    /* customization specifically for premium manufacturer partners */
    if (a.isPremium === true) {
      return -1;
    }
    if (b.isPremium === true) {
      return 1;
    }

    var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
}

export function sortPremiumManufactures(array, property, asc = true) {
  return array.sort(dynamicCustomSort(property, asc));
}

export function dynamicSortRole(property, asc = true) {
  var sortOrder = asc ? 1 : -1;
  if (property[0] === '-') {
    sortOrder = asc ? -1 : 1;
    property = property.substr(1);
  }
  return function(a, b) {
    // take owner and admin as one/same role
    let aProperty = a[property] == 16 ? 8 : a[property];
    let bProperty = b[property] == 16 ? 8 : b[property];
    var result = aProperty < bProperty ? -1 : aProperty > bProperty ? 1 : 0;
    return result * sortOrder;
  };
}

export function sortByRole(array, property, asc = true) {
  return array.sort(dynamicSortRole(property, asc));
}

export function getUniqueValuesFromArrayOfObjects(array, property) {
  return [...new Set(array.map(item => item[property]))];
}

export function getUniqueValuesForPremiumPartners(array, property) {
  return [...new Set(array.sort(dynamicCustomSort(property, true)))];
}

export function getUniqueValuesFromArray(array) {
  return Array.from(new Set(array));
}

export function getPaginatedArray(array, page_size, page_number) {
  if (!array) return [];
  --page_number; // because pages logically start with 1, but technically with 0
  return array.slice(page_number * page_size, (page_number + 1) * page_size);
}

export function checkRegionNotSelected() {
  try {
    let region = JSON.parse(localStorage.getItem('region'));
    if (region && region.name && region.apiUrl && region.authUrl && region.funcUrl) {
      return false;
    }
    return true;
  } catch (e) {
    return true;
  }
}

export function getBasicApiUrl() {
  let region = JSON.parse(localStorage.getItem('region'));
  if (region && region.apiUrl) {
    return region.apiUrl;
  }
  return '';
}

export function getBasicAuthUrl() {
  let region = JSON.parse(localStorage.getItem('region'));
  if (region && region.authUrl) {
    return region.authUrl;
  }
  return '';
}

export function getBasicFunctionUrl() {
  let region = JSON.parse(localStorage.getItem('region'));
  if (region && region.funcUrl) {
    return region.funcUrl;
  }
  return '';
}

export function formatDate(date, format) {
  const [currentDate, time] = date.split(' ');
  const [year, month, day] = currentDate.split('-');
  switch (format) {
    case 'yyyy-MM-dd':
      return `${year}-${month}-${day}`;
    case 'dd.MM.yyyy':
      return `${day}.${month}.${year}`;
    case 'MM/dd/yyyy':
      return `${month}/${day}/${year}`;
    default:
      return `${day}/${month}/${year}`;
  }
}

export function getEstimatedProductionUnit(format) {
  switch (format) {
    case 2:
      return 'lbs/h';
    default:
      return 'kg/h';
  }
}

export function getFormatedEstimatedProduction(value, format) {
  switch (format) {
    case 2:
      return value * 2.20462;
    default:
      return value;
  }
}

export function getEstimatedProductionWithUnit(value, format) {
  return `${getFormatedEstimatedProduction(value, format)} ${getEstimatedProductionUnit(format)}`;
}

export function getEstimatedProductionExport(value, format) {
  switch (format) {
    case 2:
      return value / 2.20462;
    default:
      return value;
  }
}

export function getTonnageUnit(metric) {
  return metric ? 't' : 'mlbs';
}

export function getTonnageValueFromKilograms(kg, metric) {
  return metric ? Math.round(kg / 1000) : ((2.20462 * kg) / 1000000).toFixed(3);
}

export function getTonnageValueWithUnit(kg, metric) {
  return `${getTonnageValueFromKilograms(kg, metric)} ${getTonnageUnit(metric)}`;
}

export function tonnageToKilograms(value, metric) {
  return metric ? value * 1000 : Math.round(value * 453592.9094);
}

export function getCurrentLanguage() {
  return localStorage.getItem('currentLanguage') ? localStorage.getItem('currentLanguage') : 'en';
}

export function getCalculatedFineness(value, isdtex) {
  var multiplier = Math.pow(10, 1 || 0);
  switch (isdtex) {
    case true:
      return Math.round((value / 0.39) * multiplier) / multiplier;
    case false:
      return Math.round(value * 0.39 * multiplier) / multiplier;
    default:
      return value;
  }
}
